import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import UserTable from "./UserTable";
import Button from "../../../shared/Button";
import add from "../../../../assets/img/admin/add.svg";
import Selectbox from "../../../shared/Select";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../../hooks/useAxios";
const AdminUsers = () => {

  const roleOption = [
    {
      label: "بیشترین اقامتگاه",
      value: "m_residence"
    },
    {
      label: "بیشترین پست",
      value: "m_post"
    },
    {
      label: "بیشترین رزرو",
      value: "m_post"
    },
    {
      label: "قدیمی ترین",
      value: "newest"
    },
    {
      label: "جدیدترین",
      value: "oldest"
    },
  ];
  const items = [
    {
      key: "",
      label: `همه کاربران`
      // children: ,
    },
    {
      key: "guest",
      label: `کاربران مهمان`
      // children: `Content of Tab Pane 2`,
    },
    {
      key: "host",
      label: `کاربران میزبان`
      //children: `Content of Tab Pane 3`,
    },
    {
      key: "admin",
      label: `ادمین`
      //children: `Content of Tab Pane 3`,
    }
  ];
  const [userList, setUserList] = useState();
  const [userOrder, setuserOrder] = useState();
  const [userRole, setuserRole] = useState();
  const [searchParams, setsearchParams] = useState();
  const onChange = key => {
    setuserRole(key);
  };
  const apiGetHomeInfo = useFetch({
    method: "get",
    url: "api/admin/users",
    noHeader: false,
    trigger: true,
    argFunc: res => setUserList(res.data),
    params:{
    
      role:userRole,
      order:userOrder,
      s:searchParams
    }
  });
  useEffect(() => {
   if(userRole){
    apiGetHomeInfo.reFetch()
   }
  }, [userRole])
  useEffect(() => {
    if(userOrder){
     apiGetHomeInfo.reFetch()
    }
   }, [userOrder])

  const navigate = useNavigate();
  const exteraButtons = (
    <div className="AdminUsers__header flex items-center gap-[20px] mb-[20px]">
      <p className="number">۲۴۳۲۴ کاربر</p>
      <div className="header-selectbox">
        <Selectbox
          defaultValue="بیشترین اقامتگاه"
          // placeholder="بیشترین اقامتگاه"
          option={roleOption}
          className={``}
          value={userOrder}
          onChange={(value)=>setuserOrder(value)}
        />
      </div>
      <Button varient="primary" onClick={() => navigate("/admin/add-user")}>
        <div className="flex gap-[6px]">
          <img src={add} />
          <p> افزودن کاربر جدید</p>
        </div>
      </Button>
    </div>
  );
  return (
    <div className="AdminUsers">
      <h3>کاربران جاتیک</h3>
      <div className="mt-[20px] ">
        <Tabs
          tabBarExtraContent={exteraButtons}
          defaultActiveKey="1"
          items={items}
          onChange={onChange}
        />
      </div>
      <UserTable  searchParams={searchParams} setsearchParams={setsearchParams} apiGetHomeInfo={apiGetHomeInfo} userList={userList} />
    </div>
  );
};

export default AdminUsers;
